import { useNavigate, useLocation } from 'react-router-dom'

export default function SiteNav() {
  const navigate = useNavigate()
  const location = useLocation()

  const links = [
    { label: 'Features', path: '/features' },
    { label: 'Pricing', path: '/pricing' },
    { label: 'Platform', path: '/platform' },
    { label: 'About', path: '/about' },
    { label: 'Demo', path: '/demo' },
  ]

  const isActive = (path) => location.pathname === path

  return (
    <nav style={{
      background: '#fff',
      borderBottom: '1px solid #EDE6DA',
      padding: '0 2rem',
      height: 64,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      fontFamily: "'Montserrat', sans-serif",
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Montserrat:wght@300;400;500;600&display=swap');
      `}</style>

      <div onClick={() => navigate('/')} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
        <div style={{
          width: 36, height: 36, borderRadius: '50%',
          border: '1.5px solid #B8734A',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: 'Playfair Display, serif', fontSize: 13, fontWeight: 700,
          color: '#B8734A', transition: 'all 0.2s',
        }}
          onMouseEnter={e => e.currentTarget.style.background = 'rgba(184,115,74,0.1)'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
          CS
        </div>
        <div>
          <div style={{ fontFamily: 'Playfair Display, serif', fontSize: 15, fontWeight: 600, color: '#2B2B2B', lineHeight: 1 }}>Collective Staff</div>
          <div style={{ fontSize: 9, color: '#8A9E8A', textTransform: 'uppercase', letterSpacing: '0.12em' }}>by Gallagher Collective Works</div>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        {links.map(link => (
          <button key={link.path} onClick={() => navigate(link.path)} style={{
            padding: '6px 14px',
            border: 'none',
            borderRadius: 6,
            background: isActive(link.path) ? 'rgba(184,115,74,0.1)' : 'transparent',
            color: isActive(link.path) ? '#B8734A' : 'rgba(43,43,43,0.6)',
            fontSize: 13,
            fontWeight: isActive(link.path) ? 600 : 500,
            cursor: 'pointer',
            fontFamily: "'Montserrat', sans-serif",
            transition: 'all 0.15s',
          }}
            onMouseEnter={e => { if (!isActive(link.path)) e.currentTarget.style.color = '#B8734A' }}
            onMouseLeave={e => { if (!isActive(link.path)) e.currentTarget.style.color = 'rgba(43,43,43,0.6)' }}>
            {link.label}
          </button>
        ))}
        <div style={{ width: 1, height: 20, background: '#EDE6DA', margin: '0 8px' }} />
        <button onClick={() => navigate('/login')} style={{
          padding: '7px 16px',
          border: '1.5px solid #B8734A',
          borderRadius: 8,
          background: 'transparent',
          color: '#B8734A',
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: "'Montserrat', sans-serif",
          marginRight: 8,
        }}>Sign In</button>
        <button onClick={() => navigate('/demo')} style={{
          padding: '7px 16px',
          border: 'none',
          borderRadius: 8,
          background: '#B8734A',
          color: '#fff',
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
          fontFamily: "'Montserrat', sans-serif",
        }}>Try Demo</button>
      </div>
    </nav>
  )
}
